import { useLanguage } from '../../lib/i18n/LanguageContext';
import { generateAltText, optimizePexelsUrl } from '../../lib/utils/imageOptimization';

const AboutHero = () => {
  const { t } = useLanguage();

  return (
    <div className="relative h-80 md:h-96 flex items-center">
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url("${optimizePexelsUrl('https://images.pexels.com/photos/784633/pexels-photo-784633.jpeg', 1920, 1080)}")`,
          }}
          aria-label={generateAltText(
            'interior',
            'About us background showcasing restaurant atmosphere'
          )}
        >
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
      </div>
      <div className="container-custom relative z-10 text-center text-white">
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
          {t.about.hero.title}
        </h1>
        <p className="text-lg md:text-xl max-w-2xl mx-auto">{t.about.hero.subtitle}</p>
      </div>
    </div>
  );
};

export default AboutHero;
